import React from "react";
import PropTypes from "prop-types";

import Button from "components/button/button";
import { BASE_ASSETS_URL } from "../../constants/app";

import styles from "./weAreSorry.scss";

const {
    we_are_sorry_card,
    content_row,
    content_col,
    content_info,
    title_text,
    button_box,
    fig_graphic,
} = styles;

const WeAreSorryCard = ({ title, subTitle, buttonDisplayName, onButtonClick, }) => {
    return (
        <div className={we_are_sorry_card}>
            <div className={content_row}>
                <div className={content_col}>
                    <div className={title_text}>
                        {title}
                    </div>
                    <div className={content_info}>
                        {subTitle}
                    </div>
                    <div className={button_box}>
                        <Button displayName={buttonDisplayName} onClick={onButtonClick}></Button>
                    </div>
                </div>
                <div className={content_col}>
                    <figure className={fig_graphic}>
                        <img src={`${BASE_ASSETS_URL}/images/404_Error.svg`} alt="error" />
                    </figure>
                </div>
            </div>
        </div>
    );
}

WeAreSorryCard.defaultProps = {
    title: "We’re Sorry!",
    subTitle: "Something went wrong at our end! Don’t worry, we’ll fix it soon. Please try again after some time.",
    buttonDisplayName: "Back",
    onButtonClick: () => history.back()
};

WeAreSorryCard.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    buttonDisplayName: PropTypes.string,
    onButtonClick: PropTypes.func,
};

export default WeAreSorryCard;